import React from "react";
import { Modal, Form } from "antd";
import VideoPreview from "./VideoPreview";
import ExerciseFormFields from "./ExerciseFormFields";

const ExistingExerciseModal = ({
  visible,
  onCancel,
  onSubmit,
  form,
  selectedExercise,
  getYouTubeEmbedUrl,
  isMobile,
}) => {

  if (!selectedExercise) return null;

  const videoUrl =
    selectedExercise.others_link ||
    selectedExercise.s3_path?.url ||
    selectedExercise.file?.path;
  return (
    <Modal
      title="Add Existing Exercise"
      open={visible}
      onCancel={onCancel}
      onOk={onSubmit}
      destroyOnClose
      centered={isMobile}
      wrapClassName={isMobile ? "op-compact-modal-wrap" : undefined}
      width={isMobile ? undefined : 520}
      bodyStyle={isMobile ? { maxHeight: "60vh", overflowY: "auto" } : {}}
      footer={undefined}
    >
      <Form form={form} layout="vertical">
        {videoUrl && (
          <VideoPreview
            videoPreviewURL={videoUrl}
            isLink={!!selectedExercise.others_link}
            getYouTubeEmbedUrl={getYouTubeEmbedUrl}
          />
        )}

        <ExerciseFormFields disabled={true} />
      </Form>
    </Modal>
  );
};

export default ExistingExerciseModal;
